const SCOPE_SELECTOR = [".rdt_TableCol", ".sidebar .links .link"].join(", ");
const AUTO_TITLE_ATTR = "data-auto-title";

const isTruncated = (el) =>
  el.scrollWidth > el.clientWidth &&
  getComputedStyle(el).textOverflow === "ellipsis" &&
  el.textContent.trim() !== "";

const refreshTitles = (scope) => {
  scope.querySelectorAll(`[${AUTO_TITLE_ATTR}]`).forEach((el) => {
    el.removeAttribute("title");
    el.removeAttribute(AUTO_TITLE_ATTR);
  });

  const target = [scope, ...scope.querySelectorAll("*")].find(isTruncated);
  if (!target || target.hasAttribute("title")) return;

  target.setAttribute("title", target.textContent.trim());
  target.setAttribute(AUTO_TITLE_ATTR, "");
};

/** Shows the full text as a native browser tooltip when table header / sidebar text is cut off with an ellipsis. */
export const installTruncatedTitles = () => {
  if (typeof document === "undefined") return;

  document.addEventListener("mouseover", (e) => {
    const scope = e.target.closest?.(SCOPE_SELECTOR);
    if (!scope || scope.contains(e.relatedTarget)) return;
    refreshTitles(scope);
  });
};
